import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsBuildTurnSizeM from './IconToolsBuildTurn_size_m';

const props: CreateIconArguments = {
  l: IconToolsBuildTurnSizeM,
  m: IconToolsBuildTurnSizeM,
  s: IconToolsBuildTurnSizeM,
  xs: IconToolsBuildTurnSizeM,
  name: 'IconToolsBuildTurn',
  renderType: { l: 'default', m: 'default', s: 'default', xs: 'default' },
  color: 'multiple',
};

export default props;
